export default "__VITE_ASSET__BeXACKxj__"